import { HTMLAttributes, memo } from 'react';
import { ActionIcon, ActionIconProps, BoxProps } from '@mantine/core';
import { Icon, IconName, IconProps } from '../Icon';

export type IconButtonProps = {
  iconName: IconName;
  iconSize?: IconProps['size'];
  variant?: ActionIconProps['variant'];
  size?: ActionIconProps['size'];
  w?: ActionIconProps['w'];
  loading?: boolean;
  disabled?: boolean;
} & Pick<BoxProps, 'hiddenFrom' | 'visibleFrom'> &
  HTMLAttributes<HTMLButtonElement>;

export const IconButton = memo(({ iconName, iconSize, ...props }: IconButtonProps) => {
  return (
    <ActionIcon {...props}>
      <Icon name={iconName} size={iconSize} />
    </ActionIcon>
  );
});
